import { Children, cloneElement, isValidElement } from 'react';
import type { FunctionComponent, PropsWithChildren } from 'react';
import styled from 'styled-components';
import { PositionAndSizeFromProps } from '../../utils/styledcomponents';
import type { PositionAndSizeProps } from '../../utils/styledcomponents';

export interface Props {
	className?: string;
	value: any;
	onChange: (value: any) => void;
}

const TabBar = styled.div`
	display: flex;
	flex-flow: row nowrap;
`;

const Tabs: FunctionComponent<Props> = (props: PropsWithChildren<Props>) => {
	const { value, onChange, children, ...otherProps } = props;

	const tabs = Children.map(children, (child) => {
		if (!isValidElement(child)) {
			return null;
		}
		const tabValue = child.props.value;
		const active = tabValue === value;
		const tabProps = {
			active,
			onClick: () => onChange(tabValue)
		};
		return cloneElement(child, tabProps);
	});

	return <TabBar {...otherProps}>{tabs}</TabBar>;
};

export default styled(Tabs)<PositionAndSizeProps>(PositionAndSizeFromProps);
